const React = require('react');
const noop = require('mn-utils/noop');
const Ripple = require('../../../../Ripple');

module.exports = ({icon: IC, text, disabled, testId, onClick = noop}) => (
  <Ripple
    className={`
      w48 h45 dn
      layoutRow fxdC jcC aiC
      c3E4044 b1 bs bc3E4044 r9
      (bg0.05):h
    `}
    onClick={onClick}
    data-testid={testId}
    disabled={disabled}
  >
    {IC && <IC className="sq12 (sq15|mb-1.5).MuiSvgIcon-root" />}
    <span className="dB mt4 f10">{text}</span>
  </Ripple>
)
